// Identidade Garimpa Vendas: pepita lapidada (dourado) + nome. Usada no login, no menu e no painel.
import { useAuth } from '../auth';

export const OURO = '#f5b83d';
export const SUPORTE_PADRAO = '5549988305784';

export function Logo({ size = 34 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" role="img" aria-label="Garimpa Vendas" style={{ flex: 'none' }}>
      <rect width="40" height="40" rx="10" fill="#1c1710" />
      <path d="M11 17l5-6h8l5 6-9 13z" fill="none" stroke={OURO} strokeWidth="2" strokeLinejoin="round" />
      <path d="M11 17h18M16 11l4 19M24 11l-4 19" fill="none" stroke={OURO} strokeWidth="1.4" strokeLinejoin="round" opacity="0.7" />
    </svg>
  );
}

export function Marca({ tamanho = 20, logo = 34 }: { tamanho?: number; logo?: number }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <Logo size={logo} />
      <span style={{ fontSize: tamanho, letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>
        <span style={{ fontWeight: 700 }}>Garimpa</span> <span style={{ fontWeight: 400, color: 'var(--text-2)' }}>Vendas</span>
      </span>
    </div>
  );
}

/** Link do WhatsApp do suporte com mensagem pronta. */
export function linkSuporte(numero: string | undefined, mensagem: string) {
  return `https://wa.me/${(numero || SUPORTE_PADRAO).replace(/\D/g, '')}?text=${encodeURIComponent(mensagem)}`;
}

export const telefoneSuporte = (numero: string | undefined) => {
  const d = (numero || SUPORTE_PADRAO).replace(/\D/g, '').replace(/^55/, '');
  return d.length === 11 ? `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}` : d;
};

/** Empresa bloqueada (teste grátis encerrado ou suspensa): substitui o sistema inteiro. */
export function TelaBloqueio() {
  const { me, sair, trocarEmpresa } = useAuth();
  if (!me) return null;
  const teste = me.empresa.bloqueio === 'TESTE_EXPIRADO';
  const msg = teste
    ? `Olá! Quero assinar o Garimpa Vendas. Empresa: ${me.empresa.nome}.`
    : `Olá! O acesso da empresa ${me.empresa.nome} ao Garimpa Vendas está bloqueado. Podem me ajudar?`;
  const outras = me.empresas.filter((e) => e.tenantId !== me.empresa.id && e.tenantStatus !== 'CANCELADO' && e.tenantStatus !== 'BLOQUEADO');
  return (
    <div className="auth-wrap">
      <Marca />
      <section className="auth-card" style={{ maxWidth: 520, gap: 18 }} aria-labelledby="h-bloqueio">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <h1 id="h-bloqueio" style={{ fontSize: 22 }}>{teste ? 'Seu teste grátis terminou' : 'Acesso bloqueado'}</h1>
          <span className="muted">
            {teste
              ? <>Obrigado por testar o Garimpa Vendas, <b>{me.usuario.nome.split(' ')[0]}</b>. Para continuar usando com a <b>{me.empresa.nome}</b>, fale com a gente e ative a assinatura.</>
              : <>O acesso da <b>{me.empresa.nome}</b> está bloqueado no momento. Fale com o suporte para regularizar.</>}
          </span>
        </div>
        <div className="alert info"><span>Seus clientes, contatos e histórico estão guardados. Assim que a assinatura for ativada, tudo volta exatamente como estava.</span></div>
        <a className="btn primary lg block" href={linkSuporte(me.suporteWhatsapp, msg)} target="_blank" rel="noreferrer" style={{ background: '#16a34a', borderColor: '#16a34a' }}>
          Falar com o suporte no WhatsApp
        </a>
        <span className="small muted" style={{ textAlign: 'center' }}>WhatsApp {telefoneSuporte(me.suporteWhatsapp)}</span>
        {outras.length > 0 && (
          <label className="field">
            <span>Entrar em outra empresa</span>
            <select className="select" value="" onChange={(e) => e.target.value && trocarEmpresa(e.target.value)}>
              <option value="">Selecione…</option>
              {outras.map((e) => <option key={e.tenantId} value={e.tenantId}>{e.tenantNome}</option>)}
            </select>
          </label>
        )}
        <button type="button" className="btn" onClick={() => sair()}>Sair</button>
      </section>
    </div>
  );
}

/** Faixa no topo durante o teste grátis. */
export function FaixaTeste() {
  const { me } = useAuth();
  if (!me?.empresa.trialAte) return null;
  const fim = new Date(me.empresa.trialAte);
  const dias = Math.max(0, Math.ceil((fim.getTime() - Date.now()) / 86_400_000));
  const urgente = dias <= 3;
  return (
    <div className={`faixa-teste${urgente ? ' urgente' : ''}`} role="status">
      <span>
        <b>Teste grátis:</b> {dias === 0 ? 'termina hoje' : `${dias} dia${dias > 1 ? 's' : ''} restante${dias > 1 ? 's' : ''}`} (até {fim.toLocaleDateString('pt-BR')}).
      </span>
      <a href={linkSuporte(me.suporteWhatsapp, `Olá! Quero assinar o Garimpa Vendas. Empresa: ${me.empresa.nome}.`)} target="_blank" rel="noreferrer">
        Assinar pelo WhatsApp
      </a>
    </div>
  );
}
